export const fields = `
  isHidden,
  cmsTitle,
  id
`

export const fragment = (name = 'cmsSettings') => `${name}{ ${fields} }`

export default fragment
